import { Grid } from '@mui/material';
import { toTitleCase, toFieldError, RHFMaybeFieldError } from 'common/utils';
import { ECustomFieldType } from 'enum/ECustomFieldType';
import React from 'react'
import { registryProcedureDataType } from 'types/types';
import { CustomFieldType } from 'types/types/Types'
import CustomDatePicker from '../CustomDatePicker/CustomDatePicker';
import CustomFormSelect from '../CustomFormSelect/CustomFormSelect';
import CustomFormTextInput from '../CustomFormTextInput/CustomFormTextInput';
import { useFormContext } from 'react-hook-form';

interface Props {
  field: CustomFieldType;
}

export default function CustomField({ field }: Props) {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<registryProcedureDataType>();

  switch (field.type) {
    case ECustomFieldType.FREE_TEXT:
      return (
        <Grid size={{ xs: 12, md: 6 }}>
          <CustomFormTextInput
            name={field.name}
            label={field.property?.includes('/Test') ? field.property : field.property ? toTitleCase(field.property) : field.name}
            required={field.required}
            placeholder={field.property ?? field.name}
            register={register}
            error={toFieldError(
              errors[field.name as keyof registryProcedureDataType] as RHFMaybeFieldError
            )}
          />
        </Grid>
      );

    case ECustomFieldType.DROPDOWN_LIST:
      return (
        <Grid size={{ xs: 12, md: 6 }}>
          <CustomFormSelect
            name={field.name}
            label={field.property?.includes('/Test') ? field.property : field.property ? toTitleCase(field.property) : field.name}
            required={field.required}
            placeholder={field.property ?? field.name}
            options={field.options || []}
            error={toFieldError(
              errors[field.name as keyof registryProcedureDataType] as RHFMaybeFieldError
            )}
          />
        </Grid>
      );

    case ECustomFieldType.DATE_PICKER:
    case ECustomFieldType.DATE:
      return (
        <Grid size={{ xs: 12, md: 6 }}>
          <CustomDatePicker
            name={field.name}
            label={field.property?.includes('/Test') ? field.property : field.property ? toTitleCase(field.property) : field.name}
            required={field.required}
            placeholder={field.property ?? field.name}
            control={control}
            error={toFieldError(
              errors[field.name as keyof registryProcedureDataType] as RHFMaybeFieldError
            )}
          />
        </Grid>
      );

    default:
      return null;
  }
}